import { ErrorHandler, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { BusinessFuel } from '../models/business-fuel.model';


@Injectable()
export class FuelService {

  constructor(private _http: HttpClient,
              private _errorHandler: ErrorHandler) { }

  /**
   * updates specified fuel via api
   * @param {number} businessID
   * @param {BusinessFuel} fuel
   * @return {Promise<any>}
   */
  putBusinessFuel(businessID: number, fuel: BusinessFuel): Promise<any> {
    const URL = `${environment.airportsApiUrl}/business/${businessID}/fuel/${fuel.id}`;
    try {
      const BODY = this._getFuelJSON(fuel);
      return this._http.put(URL, BODY).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  /**
   * adds specified fuel via api
   * @param {number} businessID
   * @param {BusinessFuel} fuel
   * @return {Promise<any>}
   */
  postBusinessFuel(businessID: number, fuel: BusinessFuel): Promise<any> {
    const URL = `${environment.airportsApiUrl}/business/${businessID}/fuel/`;
    try {
      const BODY = this._getFuelJSON(fuel);
      return this._http.post(URL, BODY).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  /**
   * deletes specified fuel via api
   * @param {number} businessID
   * @param {number} fuelID
   * @return {Promise<any>}
   */
  deleteBusinessFuel(businessID: number, fuelID: number): Promise<any> {
    const URL = `${environment.airportsApiUrl}/business/${businessID}/fuel/${fuelID}`;
    try {
      return this._http.delete(URL).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  /**
   * converts business fuel to json obj
   * @param {BusinessFuel} fuel
   * @return {any}
   * @private
   */
  _getFuelJSON (fuel: BusinessFuel): any {
    return {
      fuelBrand: fuel.fuelBrand,
      fuelType: fuel.fuelType,
      forWho: fuel.otherInfo,
      price: fuel.price,
      service: fuel.service,
      source: null
    };
  }
}
